import { Cause, Effect, Equal, Exit, Utils } from 'effect';

// Effect.runPromise rejects with a FiberFailure wrapper, so `error._tag` and `instanceof`
// do not match the error the effect failed with; this rejects with that error itself.
export const runEffectAsPromise = <A, E>(effect: Effect.Effect<A, E>): Promise<A> =>
  Effect.runPromiseExit(effect).then(
    Exit.match({
      onSuccess: (value) => value,
      onFailure: (cause) => {
        throw Cause.squash(cause);
      },
    }),
  );

// Deep equality over plain objects and arrays, not by reference, and regardless of key order (Effect's structural
// region applies only inside the callback).
export const isSameJson = (a: unknown, b: unknown): boolean => Utils.structuralRegion(() => Equal.equals(a, b));
